import { MaintenanceWindowManuallyApprovedPatchesSelectorController } from '../controller/MaintenanceWindowManuallyApprovedPatchesSelectorController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';

export class MaintenanceWindowManuallyApprovedPatchesSelectorWebComponent extends BaseWebComponentElement {
  public controller!: MaintenanceWindowManuallyApprovedPatchesSelectorController;
  private selectedPatchIdsArray: string[] = [];

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: MaintenanceWindowManuallyApprovedPatchesSelectorController,
    });
  }

  public get disabled(): boolean {
    const attributeValue = this.getAttribute('disabled');
    return attributeValue !== null;
  }

  public set disabled(value: boolean) {
    if (value) {
      this.setAttribute('disabled', 'true');
    } else {
      this.removeAttribute('disabled');
    }

    this.controller?.view.setDisabledInnerComponents(value);
    this.controller?.view.validateFormField();
  }

  public get selectedPatchIds(): string[] {
    return this.selectedPatchIdsArray;
  }

  public set selectedPatchIds(ids: string[]) {
    this.selectedPatchIdsArray = JSON.parse(JSON.stringify(ids));
    this.controller?.render();
  }

  public setSelectedPatchIdsWithoutSideEffects(ids: string[]): void {
    this.selectedPatchIdsArray = JSON.parse(JSON.stringify(ids));
  }
}
